import React from 'react';
import Icons from "../components/Icons"



import "../styles/Footer.css";

export default function Footer() {
    return (
        <div className="footer">
            <Icons />
            <p>&copy;2023 annaszumiec</p>

        </div>
    )
}
